import { isValidArray } from './array'

/**
 * Converts userStatus to array format for form display
 * (checkbox components expect array values)
 */
export const toUserStatusArray = (
  userStatus: string | string[] | undefined | null,
): string[] | undefined => {
  if (!userStatus) return undefined
  return typeof userStatus === 'string' ? [userStatus] : userStatus
}

/**
 * Converts userStatus array back to string for API submission
 */
export const toUserStatusString = (
  userStatus: string | string[] | undefined | null,
): string | undefined => {
  if (!userStatus) return undefined
  return isValidArray(userStatus) ? userStatus[0] : (userStatus as string)
}
